import React, { FC, useMemo } from "react"
import { Dialog } from 'primereact/dialog'
import { Button } from "primereact/button"

interface ConfirmationDialogProps {
  visible: boolean
  onHide: () => void
  title: string
  message: string
  onConfirm: () => void
  onCancel?: () => void
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = (props) => {
  const { visible, onHide, title, message, onConfirm, onCancel } = props

  const footer = useMemo(() => (
    <div>
        <Button label="Confirm" icon="pi pi-check" onClick={onConfirm} />        
        {onCancel ? <Button label="Cancel" icon="pi pi-times" onClick={onCancel} /> : null}
    </div>
  ), [onConfirm, onCancel])

  return (
    <>  
      <Dialog visible={visible} onHide={onHide} header={title} footer={footer} style={{width: '50vw'}}>
        <p>{message}</p>
      </Dialog>
    </>
  )
}

export default ConfirmationDialog